export default __webpack_public_path__ + "static/media/modeloAss_mobile.1981de6c.jpg";